<div class="full-height" [@ComponentEnterLeaveAnimation]="true">
  <section class="full-height sidebar-content" fxLayout="column">
    <vdw-header [title]="planningOrder?.productionOrder.name" svgIcon="planning-blue" [canShowClose]="true" (closeEvent)="closePlanningOrderDetail()">
      <ng-container *ngIf="canViewProductionOrder()">
        <button *ngIf="planningOrder.productionOrder.canPrintWeavingOrder()" mat-stroked-button (click)="printWeavingOrderForProductionOrder()">
          {{ 'GENERAL.ACTIONS.PRINT' | bmsTranslate }}
        </button>
        <ng-container *ngIf="canShowProcessAndQueueActions">
          <ng-container *ngIf="planningOrder.productionOrder.canBeProcessed()">
            <vdw-progress-button
              label="PLANNING.ACTIONS.PROCESS"
              [disabled]="!processAndQueueButtonsIsEnabled"
              [inProgress]="processing"
              (progressClick)="processProductionOrder()"
              [raisedButton]="false"
            >
            </vdw-progress-button>
            <vdw-progress-button
              label="PLANNING.ACTIONS.PROCESS_AND_QUEUE"
              [disabled]="!processAndQueueButtonsIsEnabled"
              [inProgress]="processingAndQueuing"
              (progressClick)="processAndQueueProductionOrder()"
              [raisedButton]="false"
            >
            </vdw-progress-button>
          </ng-container>
          <vdw-progress-button
            *ngIf="planningOrder.productionOrder.canBeQueued()"
            label="PLANNING.ACTIONS.QUEUE"
            [inProgress]="queuing"
            (progressClick)="queueProductionOrder()"
            [raisedButton]="false"
          >
          </vdw-progress-button>
        </ng-container>
      </ng-container>
    </vdw-header>
    <vdw-loading-overlay fxFlex="2 0" *ngIf="isLoadingPlanningOrder()" [hideDescription]="true" [scale]="0.7"></vdw-loading-overlay>
    <ng-container *ngIf="!isLoadingPlanningOrder()">
      <article fxFlex="2 0">
        <div fxLayout="column" fxLayoutGap="18px">
          <vdw-message-container *ngIf="canReconfirmProductionOrder()" [messages]="reconfirmWarningMessage"></vdw-message-container>

          <app-disabled-form-input [label]="'GENERAL.STATUS' | bmsTranslate" [value]="'PRODUCTION_ORDER.STATUS.' + planningOrder.productionOrder.status | bmsTranslate"></app-disabled-form-input>

          <app-disabled-form-input [label]="'GENERAL.DATETIME.START_DATE' | bmsTranslate" [value]="planningOrder.startDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>

          <app-disabled-form-input [label]="'GENERAL.DATETIME.END_DATE' | bmsTranslate" [value]="planningOrder.endDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>

          <div fxLayout="row" fxLayoutGap="24px">
            <app-disabled-form-input
              fxFlex="100"
              [label]="'GENERAL.DATETIME.DURATION' | bmsTranslate"
              [value]="planningOrder.totalRunningTimeInMs | durationFormat: 'ms' : 'd[d] h[h] m[m]'"
            ></app-disabled-form-input>
            <app-disabled-form-input fxFlex="100" [label]="'GENERAL.YIELD' | bmsTranslate: {count: 1}" [value]="getValueForYield()"></app-disabled-form-input>
          </div>

          <app-disabled-form-input
            *ngIf="planningOrder.productionOrder.dueDate"
            fxFlex="100"
            [label]="'GENERAL.DATETIME.DUE_DATE' | bmsTranslate"
            [value]="planningOrder.productionOrder.dueDate | DateTime: 'DATE_HUGE'"
          ></app-disabled-form-input>
          <app-disabled-form-input fxFlex="100" [label]="'MACHINE.MACHINE' | bmsTranslate: {count: 1}" [value]="machine.name"></app-disabled-form-input>
        </div>
      </article>
      <footer *ngIf="canViewActionsForPlanningOrder()" class="sidebar-footer" fxFlex="0 0 72px" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center">
        <button *ngIf="canReconfirmProductionOrder()" mat-stroked-button (click)="reconfirmProductionOrder()">
          {{ 'PLANNING.ACTIONS.RECONFIRM' | bmsTranslate }}
        </button>
        <button *ngIf="canRemoveOrder()" mat-stroked-button (click)="deletePlanningOrder()">
          {{ 'PLANNING.ACTIONS.REMOVE' | bmsTranslate }}
        </button>
        <button *ngIf="canViewProductionOrder()" mat-flat-button (click)="viewProductionOrder()">
          {{ 'GENERAL.ORDER_DETAILS' | bmsTranslate }}
        </button>
      </footer>
    </ng-container>
  </section>
</div>
